import React from 'react';
import type { CSSProperties, ReactNode } from 'react';
import useStyles from '../../theme/useStyles';

// tone: accent (default) | success | error | warning | neutral
export type BadgeTone = 'accent' | 'success' | 'error' | 'warning' | 'neutral';

export interface BadgeProps {
  tone?: BadgeTone;
  children?: ReactNode;
  style?: CSSProperties;
  isDarkMode?: boolean;
  accent?: string;
}

const Badge = ({ tone = 'accent', children, style, isDarkMode, accent }: BadgeProps) => {
  const s = useStyles(isDarkMode, accent);
  const t = s.t;

  const tones = {
    accent: { backgroundColor: t.primarySoft, color: t.primaryText },
    success: { backgroundColor: t.isDarkMode ? '#1E3A28' : '#E8F5E9', color: t.isDarkMode ? '#81C784' : t.income },
    error: { backgroundColor: t.isDarkMode ? '#3A1F22' : '#FFEBEE', color: t.isDarkMode ? '#FF8A80' : t.danger },
    warning: { backgroundColor: t.isDarkMode ? '#3B2A16' : '#FFF3E0', color: t.isDarkMode ? '#FFB74D' : t.warning },
    neutral: { backgroundColor: t.bgMuted, color: t.textMuted }
  };

  return <span style={{ ...s.badge, ...tones[tone], ...style }}>{children}</span>;
};

export default Badge;
